import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import FrameImg from "../../assets/icons/Frame1663.png";
import FrameImgTwo from "../../assets/icons/Frame35547.png";
import { Typography } from "@material-ui/core";
import { useStyles } from "./ServiceStyle";
import { colors } from "../../constants/colors/Colors";
import SearchIcon from "@material-ui/icons/Search";
import AddIcon from "@material-ui/icons/Add";
import Button from "@material-ui/core/Button";
import { Toolbar } from "@material-ui/core";
import UseService from "./UseService";
import clsx from "clsx";
import { useNavigate } from "react-router-dom";
import ServiceOverview from '../serviceOverview/ServiceOverview'
const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#5B6773",
    color: theme.palette.common.white,
    fontFamily: "Roboto-SemiBold",
    fontSize: 16,
    margin: 0,
    border: "none",
  },
  body: {
    fontSize: 14,
    color: "#5B6773",
    fontWeight: "400",
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: "#F4F6F8",
    },
  },
}))(TableRow);

export default function Service() {
  const classes = useStyles();
  const [
    {
      serviceData,
      searchQuery,
      onTextChangeHandler,
      cancelSearch,
      searchingFor,
    },
  ] = UseService();
  const Navigate = useNavigate();

  const createServices = () => {
    Navigate(`/create-new-services`);
  };

  const ServiceOverview = (index) => {
    Navigate(`/${index}/serviceOverview`);
  };

  return (
    <>
    {/* <ServiceOverview/> */}
      <Typography
        variant="h6"
        component="div"
        noWrap={true}
        className={classes.serviceText}
      >
        Current Services
      </Typography>

      <Toolbar disableGutters className={classes.toolbarContainer}>
        <div className={classes.searchContainer}>
          <span
            className={clsx(
              searchQuery !== "" ? classes.placeHolder : null,
              classes.commonPlaceholder
            )}
            id="sp"
          >
            Search services by{" "}
            <b className={classes.boldPlaceHolder}>
              name, plan, cloud and tags.....
            </b>
          </span>
          <input
            type={"text"}
            onChange={(e) => onTextChangeHandler(e.target.value)}
            className={classes.input}
            // placeholder='Search services by name, plan, cloud and tags.....'
          />

          <div className={classes.icon}>
            <SearchIcon style={{ color: "#92929D" }} />
          </div>
        </div>
        <Button
          onClick={() => createServices()}
          variant="contained"
          color="primary"
          size="large"
          className={classes.button}
          startIcon={<AddIcon />}
        >
          Create new service
        </Button>
      </Toolbar>

      <TableContainer
        component={Paper}
        className={classes.serviceContainer}
        style={{ minHeight: 800 }}
      >
        <Table className={classes.table} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell style={{ paddingLeft: 52 }}>
                Service
              </StyledTableCell>
              <StyledTableCell align="left">Nodes</StyledTableCell>
              <StyledTableCell align="left">Plan</StyledTableCell>
              <StyledTableCell align="left">Cloud</StyledTableCell>
              <StyledTableCell align="left">Created</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {serviceData
              .filter(searchingFor(searchQuery))
              .map((item, index) => (
                <StyledTableRow onClick={() => ServiceOverview(index)} key={index}>
                  <StyledTableCell align="left">
                    <div className={classes.tableText}>
                      <img src={FrameImg} width={30} height={30} alt="img" />

                      <div className={classes.insideText}>
                        <p
                          className={classes.textTop}
                          style={{ color: colors.primary }}
                        >
                          {item.serviceid}
                        </p>

                        <div className={classes.innerText}>
                          <p className={classes.text}>{item.serviceName}</p>
                          <div className={classes.dot} />
                          <p className={classes.text}>{item.quality}</p>
                        </div>
                      </div>
                    </div>
                  </StyledTableCell>

                  <StyledTableCell component="th" scope="row">
                    <img src={FrameImgTwo} width={44} height={10} alt="img" />
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    <p className={classes.cloudTextOne}>{item.plan}</p>
                    {item.planSpecs}
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    <div className={classes.cloudDiv}>
                      <p className={classes.cloudTextOne}>{item.cloud}</p>
                      {item.cloudSpecs}
                    </div>
                  </StyledTableCell>
                  <StyledTableCell align="left">{item.time}</StyledTableCell>
                </StyledTableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
